import React from 'react';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import { useBannerPages } from '../../hooks/useBannerPages';
import useHideOnSite from '../../hooks/useLanguageFilter';

const Banner = ({ blok, season, destination, hotel }) => {
  let banner = blok;

  const bannerReference = useBannerPages(blok.page_reference);

  if (useHideOnSite(blok.hide_on_site)) return null;

  if (bannerReference) {
    banner = JSON.parse(bannerReference.content);
  }

  return (
    <div className="banner-wrapper w-full col-span-12">
      {banner &&
        banner.body &&
        banner.body.map((nestedBlok) => (
          <StoryblokComponent
            blok={nestedBlok}
            key={nestedBlok._uid}
            season={season}
            destination={destination}
            hotel={hotel}
          />
        ))}
    </div>
  );
};

export default Banner;
